import { render, staticRenderFns } from "./assessment-tab.vue?vue&type=template&id=d3174870"
import script from "./assessment-tab.vue?vue&type=script&lang=js"
export * from "./assessment-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports